<template>
  <div class="container">
    <v-row>
      <v-col xs="12" sm="12" md="6" lg="4" xl="4">
        <v-card>
          <v-card-title class="blue accent-1 gray--text">Propietarios de bins PLP</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="owner.name"
                  label="Propietario"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="owner.short_name"
                  label="Abreviatura"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col>
                <v-btn
                  color="primary"
                  dark
                  right
                  @click="saveOwner"
                >
                <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table 
                :headers="ownersListHeaders"
                :items="ownersListBody"
                class="elevation-3 mt-5"
                no-data-text="No hay propietarios"
                :search="search"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col xs="12" sm="12" md="6" lg="4" xl="4">
        <v-card>
          <v-card-title class="blue accent-1 gray--text">Tamaños</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="size.name"
                  label="Tamaño"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col>
                <v-btn
                  color="primary"
                  dark
                  right
                  @click="saveSize"
                >
                <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table 
                :headers="sizesListHeaders"
                :items="sizesListBody"
                class="elevation-3 mt-5"
                no-data-text="No hay tamaños"
                :search="search"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col xs="12" sm="12" md="6" lg="4" xl="4">
        <v-card>
          <v-card-title class="blue accent-1 gray--text">Turnos</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="shift.name"
                  label="Turno"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col>
                <v-btn
                  color="primary"
                  dark
                  right
                  @click="saveShift"
                >
                <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table 
                :headers="shiftsListHeaders"
                :items="shiftsListBody"
                class="elevation-3 mt-5"
                no-data-text="No hay turnos"
                :search="search"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col xs="12" sm="12" md="6" lg="4" xl="4">
        <v-card>
          <v-card-title class="blue accent-1 gray--text">Colores</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="color.name"
                  label="Color"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col>
                <v-btn
                  color="primary"
                  dark
                  right
                  @click="saveColor"
                >
                <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table 
                :headers="colorsListHeaders"
                :items="colorsListBody"
                class="elevation-3 mt-5"
                no-data-text="No hay colores"
                :search="search"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col xs="12" sm="12" md="6" lg="4" xl="4">
        <v-card>
          <v-card-title class="blue accent-1 gray--text">Estados</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="state.name"
                  label="Estado"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col>
                <v-btn
                  color="primary"
                  dark
                  right
                  @click="saveState"
                >
                <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table 
                :headers="statesListHeaders"
                :items="statesListBody"
                class="elevation-3 mt-5"
                no-data-text="No hay estados"
                :search="search"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col xs="12" sm="12" md="6" lg="4" xl="4">
        <v-card>
          <v-card-title class="blue accent-1 gray--text">Propietarios de otros bins</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="otherOwner.name"
                  label="Propietario"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="otherOwner.short_name"
                  label="Abreviatura"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col>
                <v-btn
                  color="primary"
                  dark
                  right
                  @click="saveOtherOwner"
                >
                <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table 
                :headers="otherOwnersListHeaders"
                :items="otherOwnersListBody"
                class="elevation-3 mt-5"
                no-data-text="No hay otros propietarios"
                :search="search"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="sbcolor"
    >
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'

export default {
    data: () => ({
      errors: [],
      snackbar: false,
      sbcolor: 'green',
      validation_message: '',
      search: null,
      owner: {id:0, name:'', short_name:''},
      otherOwner: {id:0, name:'', short_name:''},
      color: {id:0, name:''},
      size: {id:0, name:''},
      shift: {id:0, name:''},
      state: {id:0, name:''},
      colorsListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Nombre',
          align: 'center',
          sortable: true,
          value: 'name',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      colorsListBody: [],
      ownersListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Nombre',
          align: 'center',
          sortable: true,
          value: 'name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Abreviatura',
          align: 'center',
          sortable: true,
          value: 'short_name',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      ownersListBody: [],
      otherOwnersListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Nombre',
          align: 'center',
          sortable: true,
          value: 'name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Abreviatura',
          align: 'center',
          sortable: true,
          value: 'short_name',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      otherOwnersListBody: [],
      shiftsListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Nombre',
          align: 'center',
          sortable: true,
          value: 'name',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      shiftsListBody: [],
      sizesListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Nombre',
          align: 'center',
          sortable: true,
          value: 'name',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      sizesListBody: [],
      statesListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Nombre',
          align: 'center',
          sortable: true,
          value: 'name',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      statesListBody: [],
    }),
    mounted() {
      this.loadColors();
      this.loadOwners();
      this.loadOtherOwners();
      this.loadShifts();
      this.loadSizes();
      this.loadStates();
    },
    methods:{
      async loadOwners(){
        let url = `${this.base_url}owners`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.ownersListBody = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
       async loadOtherOwners(){
        let url = `${this.base_url}other_owners`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.otherOwnersListBody = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadColors(){
        let url = `${this.base_url}colors`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.colorsListBody = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadSizes(){
        let url = `${this.base_url}sizes`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.sizesListBody = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
       async loadShifts(){
        let url = `${this.base_url}shifts`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.shiftsListBody = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadStates(){
        let url = `${this.base_url}states`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.statesListBody = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async saveColor(){
        // validation
        this.errors = [];
        if(!this.color.name){
          this.errors.push("Debe indicar color");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}colors`;
        let data = {
          'name': this.color.name,
        };
        await this.axios.post(url, data, this.headers).then((response)=>{
          this.colorsListBody.push(response.data.data);
          this.validation_message = "Grabado exitosamente!";
          this.color = {id:0, name:''};
          this.showSnackBar(false);
        }).catch((error)=>{
          this.errors = error.response.data.data;
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
        });
      },
      async saveOwner(){
        // validation
        this.errors = [];
        if(!this.owner.name){
          this.errors.push("Debe indicar propietario");
        }
        if(!this.owner.short_name){
          this.errors.push("Debe indicar abreviatura");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}owners`;
        let data = {
          'name': this.owner.name,
          'short_name': this.owner.short_name,
        };
        await this.axios.post(url, data, this.headers).then((response)=>{
          this.ownersListBody.push(response.data.data);
          this.validation_message = "Grabado exitosamente!";
          this.owner = {id:0, name:'', short_name:''};
          this.showSnackBar(false);
        }).catch((error)=>{
          this.errors = error.response.data.data;
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
        });
      },
      async saveOtherOwner(){
        // validation
        this.errors = [];
        if(!this.otherOwner.name){
          this.errors.push("Debe indicar propietario");
        }
        if(!this.otherOwner.short_name){
          this.errors.push("Debe indicar abreviatura");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}other_owners`;
        let data = {
          'name': this.otherOwner.name,
          'short_name': this.otherOwner.short_name,
        };
        await this.axios.post(url, data, this.headers).then((response)=>{
          this.otherOwnersListBody.push(response.data.data);
          this.validation_message = "Grabado exitosamente!";
          this.owner = {id:0, name:'', short_name:''};
          this.showSnackBar(false);
        }).catch((error)=>{
          this.errors = error.response.data.data;
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
        });
      },
      async saveShift(){
        // validation
        this.errors = [];
        if(!this.shift.name){
          this.errors.push("Debe indicar turno");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}shifts`;
        let data = {
          'name': this.shift.name,
        };
        await this.axios.post(url, data, this.headers).then((response)=>{
          this.shiftsListBody.push(response.data.data);
          this.validation_message = "Grabado exitosamente!";
          this.shift = {id:0, name:''};
          this.showSnackBar(false);
        }).catch((error)=>{
          this.errors = error.response.data.data;
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
        });
      },
      async saveSize(){
        // validation
        this.errors = [];
        if(!this.size.name){
          this.errors.push("Debe indicar tamaño");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}sizes`;
        let data = {
          'name': this.size.name,
        };
        await this.axios.post(url, data, this.headers).then((response)=>{
          this.sizesListBody.push(response.data.data);
          this.validation_message = "Grabado exitosamente!";
          this.size = {id:0, name:''};
          this.showSnackBar(false);
        }).catch((error)=>{
          this.errors = error.response.data.data;
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
        });
      },
      async saveState(){
        // validation
        this.errors = [];
        if(!this.state.name){
          this.errors.push("Debe indicar estado");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}states`;
        let data = {
          'name': this.state.name,
        };
        await this.axios.post(url, data, this.headers).then((response)=>{
          this.statesListBody.push(response.data.data);
          this.validation_message = "Grabado exitosamente!";
          this.state = {id:0, name:''};
          this.showSnackBar(false);
        }).catch((error)=>{
          this.errors = error.response.data.data;
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
        });
      },
      showSnackBar(error){
        if(error){
          this.sbcolor = 'red';
        }else{
          this.sbcolor = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      ...mapMutations(['actualizarBaseUrl']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'headers']),
    },
    components:{
    }
  }
</script>
